import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/homepage_header_25fps.mp4")